import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { 
  Search, 
  MapPin, 
  Briefcase, 
  Clock,
  Filter,
  ArrowRight,
  Users,
  Heart,
  Zap,
  Award,
} from "lucide-react";
import { Link } from "react-router-dom";
import { useJob } from "../context/JobContext";
import { jobAPI } from "../services/api";

const CareersPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("All Locations");
  const [selectedType, setSelectedType] = useState("All Types");
  const { error } = useJob();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [locations, setLocation] = useState([]);
  const [jobTypes, setJobsType] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [backJobs, setBackJobs] = useState([]);

  const benefits = [
    {
      icon: Heart,
      title: "Health & Wellness",
      description:
        "Comprehensive health insurance, dental, vision, and wellness programs.",
    },
    {
      icon: Zap,
      title: "Flexible Work",
      description:
        "Remote work options, flexible hours, and work-life balance support.",
    },
    {
      icon: Award,
      title: "Growth & Learning",
      description:
        "Professional development, training programs, and career advancement opportunities.",
    },
    {
      icon: Users,
      title: "Great Team",
      description:
        "Collaborative environment with talented and passionate professionals.",
    },
  ];

  // const mockJobs = [
  //   {
  //     id: 1,
  //     title: "Senior Software Engineer",
  //     company: "TechMind Infosys",
  //     location: "San Francisco, CA",
  //     type: "Full Time",
  //     experience: "5+ years",
  //     salary: "$120,000 - $150,000",
  //     posted: "2 days ago",
  //     description:
  //       "We are looking for a Senior Software Engineer to join our growing team...",
  //     tags: ["React", "Node.js", "AWS", "TypeScript"],
  //   },
  //   {
  //     id: 2,
  //     title: "UX/UI Designer",
  //     company: "TechMind Infosys",
  //     location: "Remote",
  //     type: "Full Time",
  //     experience: "3+ years",
  //     salary: "$90,000 - $120,000",
  //     posted: "1 week ago",
  //     description:
  //       "Join our design team to create beautiful and intuitive user experiences...",
  //     tags: ["Figma", "Adobe Creative Suite", "User Research", "Prototyping"],
  //   },
  //   {
  //     id: 3,
  //     title: "Product Manager",
  //     company: "TechMind Infosys",
  //     location: "New York, NY",
  //     type: "Full Time",
  //     experience: "4+ years",
  //     salary: "$130,000 - $160,000",
  //     posted: "3 days ago",
  //     description:
  //       "Lead product strategy and development for our HR technology platform...",
  //     tags: [
  //       "Product Strategy",
  //       "Agile",
  //       "Data Analysis",
  //       "Stakeholder Management",
  //     ],
  //   },
  //   {
  //     id: 4,
  //     title: "DevOps Engineer",
  //     company: "TechMind Infosys",
  //     location: "Austin, TX",
  //     type: "Full Time",
  //     experience: "3+ years",
  //     salary: "$110,000 - $140,000",
  //     posted: "5 days ago",
  //     description:
  //       "Help us build and maintain our cloud infrastructure and deployment pipelines...",
  //     tags: ["Docker", "Kubernetes", "AWS", "CI/CD"],
  //   },
  //   {
  //     id: 5,
  //     title: "Marketing Specialist",
  //     company: "TechMind Infosys",
  //     location: "Remote",
  //     type: "Full Time",
  //     experience: "2+ years",
  //     salary: "$70,000 - $90,000",
  //     posted: "1 week ago",
  //     description:
  //       "Drive our marketing initiatives and help grow our brand presence...",
  //     tags: ["Digital Marketing", "Content Creation", "SEO", "Social Media"],
  //   },
  //   {
  //     id: 6,
  //     title: "Data Scientist",
  //     company: "TechMind Infosys",
  //     location: "Seattle, WA",
  //     type: "Full Time",
  //     experience: "4+ years",
  //     salary: "$140,000 - $170,000",
  //     posted: "4 days ago",
  //     description:
  //       "Apply machine learning and data science to improve our HR solutions...",
  //     tags: ["Python", "Machine Learning", "SQL", "Statistics"],
  //   },
  // ];

  // Helper to get jobs from localStorage
  function getLocalStorageJobs() {
    try {
      const stored = localStorage.getItem("techmind_jobs");
      return stored ? JSON.parse(stored) : [];
    } catch (err) {
      console.error("Error retrieving jobs from storage:", err);
      return [];
    }
  }

  // Flags for countries
  const flags = {
    "United States":
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 40'%3E%3Crect width='60' height='40' fill='%23f0f0f0'/%3E%3Crect width='60' height='3.08' y='0' fill='%23d80027'/%3E%3Crect width='60' height='3.08' y='6.15' fill='%23d80027'/%3E%3Crect width='60' height='3.08' y='12.31' fill='%23d80027'/%3E%3Crect width='60' height='3.08' y='18.46' fill='%23d80027'/%3E%3Crect width='60' height='3.08' y='24.62' fill='%23d80027'/%3E%3Crect width='60' height='3.08' y='30.77' fill='%23d80027'/%3E%3Crect width='60' height='3.08' y='36.92' fill='%23d80027'/%3E%3Crect width='24' height='20.77' fill='%232e4b80'/%3E%3C/svg%3E",
    "United Kingdom":
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 40'%3E%3Crect width='60' height='40' fill='%23012169'/%3E%3Cpath d='M0,0 L60,40 M60,0 L0,40' stroke='%23fff' stroke-width='6'/%3E%3Cpath d='M30,0 L30,40 M0,20 L60,20' stroke='%23fff' stroke-width='10'/%3E%3Cpath d='M30,0 L30,40 M0,20 L60,20' stroke='%23c8102e' stroke-width='6'/%3E%3Cpath d='M0,0 L60,40 M60,0 L0,40' stroke='%23c8102e' stroke-width='2'/%3E%3C/svg%3E",
    India:
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 40'%3E%3Crect width='60' height='40' fill='%23f0f0f0'/%3E%3Crect width='60' height='13.33' y='0' fill='%23ff9933'/%3E%3Crect width='60' height='13.33' y='26.67' fill='%23138808'/%3E%3Ccircle cx='30' cy='20' r='4' fill='%23000080'/%3E%3C/svg%3E",
    "United Arab Emirates":
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 40'%3E%3Crect width='60' height='40' fill='%23f0f0f0'/%3E%3Crect width='20' height='40' fill='%23009e49'/%3E%3Crect width='60' height='13.33' y='0' fill='%23ce1126'/%3E%3Crect width='60' height='13.33' y='26.67' fill='%23000'/%3E%3C/svg%3E",
    Singapore:
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 40'%3E%3Crect width='60' height='40' fill='%23f0f0f0'/%3E%3Crect width='60' height='20' fill='%23ed2939'/%3E%3Ccircle cx='16' cy='20' r='6' fill='%23f0f0f0'/%3E%3Ccircle cx='20' cy='20' r='6' fill='%23f0f0f0'/%3E%3Cpath d='M11,16 L25,24 M25,16 L11,24' stroke='%23ed2939' stroke-width='1'/%3E%3C/svg%3E",
  };

  // Default jobs
  const defaultJobs = [
    {
      id: 1,
      title: "Senior Software Engineer",
      company: "TechGlobal Inc.",
      location: "United States",
      flag: flags["United States"],
      type: "Full-time",
      industry: "Technology",
      skills: ["React", "Node.js", "AWS"],
      posted: "2 days ago",
      salary: "$120,000 - $150,000",
      experienceLevel: "Senior",
      description:
        "We are seeking a talented Senior Software Engineer to join our team at TechGlobal Inc. This is an exciting opportunity to work on cutting-edge projects in a collaborative environment.",
      responsibilities: [
        "Design, develop, and maintain high-quality software solutions",
        "Lead technical design discussions and architecture decisions",
        "Mentor junior developers and conduct code reviews",
        "Collaborate with cross-functional teams to define and implement new features",
        "Troubleshoot and resolve complex technical issues",
      ],
      requirements: [
        "5+ years of experience in software development",
        "Strong proficiency in React, Node.js, and AWS",
        "Experience with microservices architecture",
        "Excellent problem-solving skills and attention to detail",
        "Bachelor's degree in Computer Science or related field",
      ],
      benefits: [
        "Competitive salary and comprehensive benefits package",
        "Flexible working arrangements and remote options",
        "Professional development budget",
        "Regular team events and activities",
        "Modern office with amenities",
      ],
    },
    {
      id: 2,
      title: "UX/UI Designer",
      company: "Creative Solutions",
      location: "United Kingdom",
      flag: flags["United Kingdom"],
      type: "Full-time",
      industry: "Design",
      skills: ["Figma", "Adobe XD", "Sketch"],
      posted: "3 days ago",
      salary: "£65,000 - £80,000",
      experienceLevel: "Mid-Level",
      description:
        "Creative Solutions is looking for a talented UX/UI Designer to create exceptional user experiences for our clients' digital products. You'll work closely with our product and development teams to design intuitive and visually appealing interfaces.",
      responsibilities: [
        "Create wireframes, prototypes, and high-fidelity designs",
        "Conduct user research and usability testing",
        "Develop user flows and information architecture",
        "Collaborate with developers to ensure design implementation",
        "Stay current with UX/UI trends and best practices",
      ],
      requirements: [
        "3+ years of experience in UX/UI design",
        "Proficiency in Figma, Adobe XD, and Sketch",
        "Strong portfolio demonstrating user-centered design process",
        "Understanding of accessibility standards",
        "Excellent communication and presentation skills",
      ],
      benefits: [
        "Competitive salary with annual bonus",
        "Flexible working hours and remote options",
        "Professional development opportunities",
        "Creative and collaborative work environment",
        "Regular team social events",
      ],
    },
    {
      id: 3,
      title: "Data Scientist",
      company: "Analytics Pro",
      location: "India",
      flag: flags.India,
      type: "Full-time",
      industry: "Data",
      skills: ["Python", "TensorFlow", "SQL"],
      posted: "1 week ago",
      salary: "₹1,500,000 - ₹2,000,000",
      experienceLevel: "Mid-Level",
    },
    {
      id: 4,
      title: "DevOps Engineer",
      company: "Cloud Systems",
      location: "United Arab Emirates",
      flag: flags["United Arab Emirates"],
      type: "Full-time",
      industry: "Infrastructure",
      skills: ["Kubernetes", "Docker", "CI/CD"],
      posted: "5 days ago",
      salary: "AED 25,000 - AED 35,000 monthly",
      experienceLevel: "Senior",
    },
    {
      id: 5,
      title: "Full Stack Developer",
      company: "Web Innovators",
      location: "Singapore",
      flag: flags.Singapore,
      type: "Full-time",
      industry: "Technology",
      skills: ["JavaScript", "React", "Node.js", "MongoDB"],
      posted: "Just now",
      salary: "SGD 8,000 - SGD 12,000 monthly",
      experienceLevel: "Mid-Level",
    },
    {
      id: 6,
      title: "Product Manager",
      company: "Digital Solutions",
      location: "United States",
      flag: flags["United States"],
      type: "Full-time",
      industry: "Product",
      skills: ["Agile", "Scrum", "User Research"],
      posted: "3 days ago",
      salary: "$110,000 - $140,000",
      experienceLevel: "Senior",
    },
    {
      id: 7,
      title: "Frontend Developer",
      company: "MobileTech",
      location: "India",
      flag: flags.India,
      type: "Full-time",
      industry: "Technology",
      skills: ["React Native", "JavaScript", "CSS"],
      posted: "2 weeks ago",
      salary: "₹1,200,000 - ₹1,800,000",
      experienceLevel: "Mid-Level",
    },
  ];

  useEffect(() => {
    loadJobs();
  }, []);

  function mergeJobs(localJobs) {
    let data=localStorage.getItem("default_jobs") ? JSON.parse(localStorage.getItem("default_jobs")): [];
    const defaultStored =data?.length ? data:defaultJobs;

    // Merge jobs, local first, then default jobs not already in local
    // const localIds = new Set(localJobs.map(j => j.id));
    const merged = [...localJobs, ...defaultStored];
    // for (const job of defaultStored) {
    //   if (!localIds.has(job.id)) {
    //     merged.push(job);
    //   }
    // }
    return merged;
  }

  async function loadJobs() {
    setLoading(true);
    try {
      const localJobs = getLocalStorageJobs();
      // You can also fetch from API if needed, or just use local+default
      const jobsToShow = mergeJobs(localJobs);
      setJobs(jobsToShow);
      // For filters
      setLocation([
        "All Locations",
        ...Array.from(new Set(jobsToShow.map(job => job.location).filter(Boolean)))
      ]);
      setJobsType([
        "All Types",
        ...Array.from(new Set(jobsToShow.map(job => job.type).filter(Boolean)))
      ]);
      setFilteredJobs(jobsToShow);
      setBackJobs(jobsToShow);
    } catch (err) {
      console.error("Error loading jobs:", err);
    } finally {
      setLoading(false);
    }
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };

  useEffect(() => {
    // Normalize filter input
    const locationFilter = selectedLocation?.toLowerCase();
    const typeFilter = selectedType?.toLowerCase();
    const term = searchTerm?.toLowerCase();
  
    // Check if any filter is applied
    if (term || locationFilter !== 'all locations' || typeFilter !== 'all types') {
      const filtered = backJobs.filter((job) => {
        const matchTitle = job.title?.toLowerCase().includes(term);
        const matchLocation = locationFilter === 'all locations' || job.location?.toLowerCase() === locationFilter;
        const matchType = typeFilter === 'all types' || job.type?.toLowerCase() === typeFilter;
  
        return matchTitle && matchLocation && matchType;
      });
  
      setFilteredJobs(filtered);
    } else {
      setFilteredJobs(backJobs);
    }
  }, [searchTerm, selectedLocation, selectedType, backJobs]);
  

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-[#1A193B] pt-20 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-3 lg:px-4 py-24 lg:py-32">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="text-4xl lg:text-6xl font-bold mb-6">
              Find Your Dream Job
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
              {/* Be part of a team that's revolutionizing HR technology and helping businesses find their perfect talent. */}
              Search thousands of job opportunities worldwide_
            </p>
          </motion.div>
        </div>
      </section>

      {/* Search Section */}
      <section className="py-12 bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-4">
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search jobs by title, company, or skill..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <select
              value={selectedLocation}
              onChange={(e) => setSelectedLocation(e.target.value)}
              className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              {locations.map((location) => (
                <option key={location} value={location}>
                  {location}
                </option>
              ))}
            </select>
            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              {jobTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
        </div>
      </section>

      {/* Jobs Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
              Available Opportunities
            </h2>
            <span className="text-gray-500 text-sm font-medium">
              Showing {filteredJobs?.length || 0} of {jobs?.length || 0} jobs
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredJobs?.map((job) => (
              <div
                key={job.id}
                className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col h-full transition hover:shadow-lg"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1 min-w-0">
                    <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1 line-clamp-2">
                      {job.title}
                    </h3>
                    <a
                      href="#"
                      className="text-blue-600 hover:underline font-medium text-base mb-1 block truncate"
                      tabIndex={-1}
                    >
                      {job.company}
                    </a>
                    <div className="flex items-center text-gray-500 text-sm mt-1">
                    <MapPin className="w-4 h-4 mr-1" />
                    {job.location}
                  </div>
                  </div>
                  {job.flag && (
                    <img
                      src={job.flag}
                      alt="flag"
                      className="w-7 h-5 rounded-sm ml-2 flex-shrink-0 border border-gray-200"
                    />
                  )}
                </div>

                {job.skills && job.skills.length > 0 && (
                <div className="flex flex-wrap gap-2 mb-4">
                    {job.skills.map((skill, idx) => (
                    <span
                        key={idx}
                        className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-medium"
                    >
                        {skill}
                    </span>
                  ))}
                  </div>
                )}

                <div className="flex items-center justify-between text-gray-500 text-sm mb-6 mt-auto">
                  <span>{job.posted}</span>
                  <span className="font-semibold text-gray-900">{job.salary}</span>
                </div>

                <div className="border-t pt-4 mt-auto">
                  <Link
                    to={{ pathname: `/job/${job.id}` }}
                    state={{ job }}
                    className="block text-center text-blue-600 font-semibold hover:underline text-base"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            ))}
          </div>

          {filteredJobs?.length === 0 && (
            <div className="text-center py-12">
              <Search className="w-16 h-16 text-gray-400 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                No jobs found
              </h3>
              <p className="text-gray-600">
                Try adjusting your search criteria or check back later for new opportunities.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Why Work With Us?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We offer competitive benefits and a great work environment to help
              you thrive.
            </p>
          </motion.div>

          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
          >
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                className="text-center"
              >
                <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-6">
                  <benefit.icon className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#1A193B] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Don't See a Perfect Match?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Upload your CV to our talent pool, and we'll contact you when a
              position matching your skills becomes available.
</p>
            <Link to={"/cv-upload"} className="block">
              <button className="inline-flex items-center px-8 py-4 bg-white text-blue-600 hover:bg-gray-100 rounded-lg font-semibold transition-colors duration-200">
              Submit Your CV
              {/* <ArrowRight className="ml-2 w-5 h-5" /> */}
            </button>
            </Link>
          </motion.div>
        </div>
      </section>
 </div>
  );
};

export default CareersPage; 
